// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================================
   AdventurePage.css - Full Adventure Landing Page
   ===================================================== */

/* -------- Reset / base -------- */
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* -------- Page shell -------- */
.adv-page {
  min-height: 100vh;
  background: #0d0e12;
  color: #fff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  overflow-x: hidden;
}

.c-green {
  color: #5AAF9A;
}

/* =====================================================================
   NAVBAR
   ===================================================================== */

.an {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 900;
  display: flex;
  align-items: center;
  gap: 0;
  padding: 1.25rem 32px 0.75rem 32px;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.55) 0%, transparent 100%);
  transition: background 0.35s, box-shadow 0.35s;
}

.an--scrolled {
  background: rgba(6, 12, 4, 0.88);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  box-shadow: 0 2px 24px rgba(0, 0, 0, 0.4);
}

/* Back to Hub */
.an__back-hub {
  background: transparent;
  border: 1px solid rgba(90, 175, 154, 0.55);
  border-radius: 20px;
  padding: 6px 14px;
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #5AAF9A;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s, border-color 0.2s, color 0.2s;
  flex-shrink: 0;
}

.an__back-hub:hover {
  background: rgba(90, 175, 154, 0.12);
  border-color: #5AAF9A;
  color: #5AAF9A;
}

.an__logo {
  display: flex;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  text-decoration: none;
  flex-shrink: 0;
  margin-right: 40px;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.an__logo:hover {
  opacity: 0.92;
  transform: translateY(-1px);
}

.an__logo-img {
  height: clamp(42px, 3.2vw, 56px);
  width: auto;
  object-fit: contain;
  display: block;
}

/* Link list */
.an__links {
  display: flex;
  align-items: center;
  gap: 4px;
  list-style: none;
  flex: 1 1;
}

.an__item {
  position: relative;
}

.an__link {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 14px;
  font-size: 13.5px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.82);
  text-decoration: none;
  border-radius: 8px;
  white-space: nowrap;
  transition: background 0.18s, color 0.18s;
  background: none;
  border: none;
  cursor: pointer;
  font-family: inherit;
}

.an__link:hover,
.an__link:focus-visible {
  background: rgba(255, 255, 255, 0.07);
  color: #fff;
}

/* Dropdown */
.an__dd {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  min-width: 180px;
  background: #0e1c0b;
  border: 1px solid rgba(255, 255, 255, 0.09);
  border-radius: 12px;
  padding: 6px;
  opacity: 0;
  pointer-events: none;
  transform: translateY(-6px);
  transition: opacity 0.2s, transform 0.2s;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);
}

.an__item:hover .an__dd {
  opacity: 1;
  pointer-events: all;
  transform: translateY(0);
}

.an__dd-item {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 9px 14px;
  border-radius: 8px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  cursor: pointer;
  transition: background 0.15s;
}

.an__dd-item:hover {
  background: rgba(255, 255, 255, 0.07);
  color: #fff;
}

/* Right cluster */
.an__right {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex-shrink: 0;
}

.an__ghost {
  padding: 8px 18px;
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 22px;
  cursor: pointer;
  transition: background 0.18s, border-color 0.18s;
  white-space: nowrap;
}

.an__ghost:hover {
  background: rgba(255, 255, 255, 0.07);
  border-color: rgba(255, 255, 255, 0.38);
}

.an__cta {
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 700;
  color: #080e06;
  background: #5AAF9A;
  border: none;
  border-radius: 22px;
  cursor: pointer;
  transition: opacity 0.18s;
  white-space: nowrap;
}

.an__cta:hover {
  opacity: 0.88;
}

/* Cart */
.an__cart {
  position: relative;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  padding: 4px 8px;
  line-height: 1;
}

.an__badge {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #5AAF9A;
  color: #000;
  font-size: 9px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Search */
.an__search-wrap {
  position: relative;
}

.an__search-input {
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  color: #fff;
  padding: 7px 16px;
  font-size: 13px;
  outline: none;
  width: 180px;
  transition: width 0.3s, border-color 0.2s;
}

.an__search-input::placeholder {
  color: rgba(255, 255, 255, 0.4);
}

.an__search-input:focus {
  width: 240px;
  border-color: rgba(90, 175, 154, 0.5);
}

/* Hamburger */
.an__hamburger {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  margin-left: 8px;
}

.an__hamburger span {
  display: block;
  width: 22px;
  height: 2px;
  background: #fff;
  border-radius: 2px;
  transition: transform 0.25s, opacity 0.25s;
}

/* Overlay + Drawer */
.an__overlay {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 800;
}

.an__overlay--open {
  display: block;
}

.an__drawer {
  position: fixed;
  top: 0;
  left: -280px;
  width: 280px;
  height: 100%;
  background: #0c1a09;
  z-index: 850;
  padding: 80px 24px 32px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  transition: left 0.3s cubic-bezier(.4, 0, .2, 1);
  overflow-y: auto;
}

.an__drawer--open {
  left: 0;
}

.an__drawer .an__link {
  width: 100%;
  font-size: 15px;
  padding: 12px 16px;
}

.an__drawer .an__ghost,
.an__drawer .an__cta {
  width: 100%;
  text-align: center;
  margin-top: 8px;
  padding: 12px 20px;
  font-size: 14px;
}

/* =====================================================================
   HERO
   ===================================================================== */
.ah {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.ah__bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
}

.ah__overlay {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(to right, rgba(0, 0, 0, 0.72) 40%, rgba(0, 0, 0, 0.22) 100%),
    linear-gradient(to top, rgba(8, 14, 6, 0.95) 0%, transparent 40%);
}

.ah__content {
  position: relative;
  z-index: 2;
  padding: 130px 80px 80px;
  max-width: 820px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.ah__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  letter-spacing: 3px;
  font-weight: 700;
  color: #5AAF9A;
  background: rgba(90, 175, 154, 0.12);
  border: 1px solid rgba(90, 175, 154, 0.28);
  border-radius: 20px;
  padding: 5px 14px;
  width: fit-content;
}

.ah__title {
  font-size: clamp(34px, 4.8vw, 62px);
  font-weight: 900;
  line-height: 1.12;
  letter-spacing: -0.5px;
  color: #fff;
}

.ah__desc {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.ah__sub {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.68;
}

/* Search bar */
.ah__search {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ah__sf {
  display: flex;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 50px;
  overflow: hidden;
  transition: border-color 0.25s;
}

.ah__sf:focus-within {
  border-color: rgba(90, 175, 154, 0.55);
}

.ah__sdiv {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 20px;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
}

.ah__sdiv:last-of-type {
  border-right: none;
}

.ah__sdiv input,
.ah__sdiv select {
  background: none;
  border: none;
  outline: none;
  color: #fff;
  font-size: 14px;
  width: 100%;
  height: 52px;
}

.ah__sdiv input::placeholder {
  color: rgba(255, 255, 255, 0.45);
}

.ah__sdiv select option {
  background: #0c1a09;
  color: #fff;
}

.ah__sdiv .ah__icon {
  font-size: 16px;
  flex-shrink: 0;
}

.ah__sbtn {
  background: #5AAF9A;
  border: none;
  border-radius: 50px;
  margin: 5px;
  padding: 0 28px;
  font-size: 14px;
  font-weight: 700;
  color: #080e06;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.2s;
}

.ah__sbtn:hover {
  opacity: 0.88;
}

.ah__date {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.45);
  padding-left: 8px;
}

/* Social proof */
.ah__proof {
  display: flex;
  align-items: center;
  gap: 28px;
  flex-wrap: wrap;
  margin-top: 12px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.ah__proof-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ah__proof-item strong {
  font-size: 20px;
  font-weight: 800;
  color: #5AAF9A;
  letter-spacing: -0.3px;
}

.ah__proof-item span {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.65);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.ah__proof-sep {
  width: 1px;
  height: 32px;
  background: rgba(255, 255, 255, 0.15);
}

.ah__avatars {
  display: flex;
}

.ah__avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 2px solid #080e06;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -10px;
  color: #080e06;
}

.ah__avatars .ah__avatar:first-child {
  margin-left: 0;
}

.ah__proof-txt {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.4;
}

.ah__proof-txt strong {
  color: #fff;
}

/* =====================================================================
   SHARED SECTION SHELL
   ===================================================================== */
.adv-sec {
  padding: 90px 80px;
}

.adv-sec--alt {
  background: #090a0e;
}

.adv-sec__hdr {
  text-align: center;
  margin-bottom: 52px;
}

.sec-step-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #5AAF9A;
  background: rgba(90, 175, 154, 0.12);
  border: 1px solid rgba(90, 175, 154, 0.3);
  border-radius: 20px;
  padding: 5px 14px;
  margin-bottom: 14px;
}

.adv-sec__eyebrow {
  display: inline-block;
  font-size: 10px;
  letter-spacing: 3px;
  font-weight: 700;
  color: #5AAF9A;
  margin-bottom: 12px;
}

.adv-sec__title {
  font-size: clamp(28px, 4vw, 42px);
  font-weight: 900;
  color: #fff;
  margin-bottom: 10px;
}

.adv-sec__sub {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.55);
  max-width: 540px;
  margin: 0 auto;
  line-height: 1.65;
}

/* =====================================================================
   CATEGORIES
   ===================================================================== */
.adv-cats {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 16px;
}

@media (max-width: 1100px) {
  .adv-cats {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 600px) {
  .adv-cats {
    grid-template-columns: repeat(2, 1fr);
  }
}

.adv-cat {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 22px 12px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 16px;
  cursor: pointer;
  transition: border-color 0.22s, background 0.22s, transform 0.22s;
}

.adv-cat:hover {
  border-color: rgba(90, 175, 154, 0.45);
  background: rgba(90, 175, 154, 0.07);
  transform: translateY(-3px);
}

.adv-cat__icon {
  font-size: 28px;
  line-height: 1;
}

.adv-cat__label {
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.75);
  text-align: center;
}

/* =====================================================================
   FEATURED EVENTS GRID
   ===================================================================== */
.adv-ev-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

@media (max-width: 960px) {
  .adv-ev-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 580px) {
  .adv-ev-grid {
    grid-template-columns: 1fr;
  }
}

.adv-ev-card {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 18px;
  overflow: hidden;
  transition: transform 0.25s, border-color 0.25s, box-shadow 0.25s;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.adv-ev-card:hover {
  transform: translateY(-4px);
  border-color: rgba(90, 175, 154, 0.3);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
}

.adv-ev-card__img {
  height: 180px;
  display: flex;
  align-items: flex-end;
  padding: 12px 14px;
  position: relative;
}

.adv-ev-card__badge {
  font-size: 10px;
  font-weight: 700;
  background: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  padding: 4px 10px;
  color: #fff;
  backdrop-filter: blur(6px);
}

.adv-ev-card__body {
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1;
}

.adv-ev-card__name {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  line-height: 1.3;
}

.adv-ev-card__meta {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.adv-ev-card__foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: auto;
  padding-top: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
}

.adv-ev-card__price {
  font-size: 14px;
  font-weight: 700;
  color: #5AAF9A;
}

.adv-ev-card__btn {
  background: #5AAF9A;
  border: none;
  border-radius: 20px;
  padding: 7px 18px;
  font-size: 12px;
  font-weight: 700;
  color: #080e06;
  cursor: pointer;
  transition: opacity 0.18s;
}

.adv-ev-card__btn:hover {
  opacity: 0.85;
}

/* =====================================================================
   HOW IT WORKS
   ===================================================================== */
.adv-how__row {
  display: flex;
  align-items: flex-start;
  gap: 0;
}

.adv-how__step {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
  padding: 0 24px;
}

.adv-how__num {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 2px;
  color: rgba(90, 175, 154, 0.6);
}

.adv-how__icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: rgba(90, 175, 154, 0.1);
  border: 2px solid rgba(90, 175, 154, 0.22);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
}

.adv-how__step h3 {
  font-size: 18px;
  font-weight: 800;
  color: #fff;
}

.adv-how__step p {
  font-size: 13.5px;
  color: rgba(255, 255, 255, 0.55);
  line-height: 1.65;
  max-width: 260px;
}

.adv-how__arrow {
  display: flex;
  align-items: center;
  padding-top: 36px;
  color: rgba(90, 175, 154, 0.4);
  font-size: 24px;
  flex-shrink: 0;
}

/* =====================================================================
   UPCOMING EVENTS
   ===================================================================== */
.adv-up__list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.adv-up__item {
  display: flex;
  align-items: center;
  gap: 20px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 14px;
  padding: 18px 24px;
  cursor: pointer;
  transition: border-color 0.22s, background 0.22s;
}

.adv-up__item:hover {
  border-color: rgba(90, 175, 154, 0.3);
  background: rgba(90, 175, 154, 0.04);
}

.adv-up__datebox {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  background: rgba(90, 175, 154, 0.12);
  border: 1px solid rgba(90, 175, 154, 0.25);
  border-radius: 10px;
  flex-shrink: 0;
}

.adv-up__mon {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #5AAF9A;
  text-transform: uppercase;
}

.adv-up__day {
  font-size: 20px;
  font-weight: 900;
  color: #fff;
  line-height: 1;
}

.adv-up__info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.adv-up__name {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
}

.adv-up__detail {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
}

.adv-up__right {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-left: auto;
  flex-shrink: 0;
}

.adv-up__cat {
  font-size: 11px;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 20px;
  background: rgba(90, 175, 154, 0.12);
  color: #5AAF9A;
}

.adv-up__price {
  font-size: 14px;
  font-weight: 700;
  color: #5AAF9A;
  min-width: 52px;
  text-align: right;
}

.adv-up__btn {
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 20px;
  padding: 7px 18px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  transition: background 0.18s;
}

.adv-up__btn:hover {
  background: rgba(90, 175, 154, 0.18);
  border-color: rgba(90, 175, 154, 0.4);
}

/* =====================================================================
   TESTIMONIALS
   ===================================================================== */
.adv-testi__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

@media (max-width: 860px) {
  .adv-testi__grid {
    grid-template-columns: 1fr;
  }
}

.adv-testi__card {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  padding: 28px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  transition: border-color 0.25s;
}

.adv-testi__card:hover {
  border-color: rgba(90, 175, 154, 0.25);
}

.adv-testi__stars {
  font-size: 16px;
  letter-spacing: 2px;
  color: #5AAF9A;
}

.adv-testi__text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.72);
  line-height: 1.7;
  flex: 1 1;
  font-style: italic;
}

.adv-testi__author {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
}

.adv-testi__avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 800;
  color: #fff;
  flex-shrink: 0;
}

.adv-testi__name {
  font-size: 14px;
  font-weight: 700;
  color: #fff;
}

.adv-testi__event {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.45);
}

/* =====================================================================
   ORGANIZERS
   ===================================================================== */
.adv-org {
  background: #0d0e12;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.adv-org__inner {
  display: flex;
  align-items: center;
  gap: 80px;
  padding: 90px 80px;
}

@media (max-width: 900px) {
  .adv-org__inner {
    flex-direction: column;
    gap: 48px;
    padding: 60px 28px;
  }
}

.adv-org__left {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.adv-org__eyebrow {
  font-size: 10px;
  letter-spacing: 3px;
  font-weight: 700;
  color: #5AAF9A;
}

.adv-org__title {
  font-size: clamp(28px, 3.5vw, 42px);
  font-weight: 900;
  color: #fff;
  line-height: 1.12;
}

.adv-org__sub {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.55);
  line-height: 1.7;
  max-width: 440px;
}

.adv-org__cta {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.adv-org__btn-primary {
  background: #5AAF9A;
  color: #080e06;
  border: none;
  border-radius: 26px;
  padding: 13px 30px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.18s;
}

.adv-org__btn-primary:hover {
  opacity: 0.88;
}

.adv-org__btn-ghost {
  background: transparent;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 26px;
  padding: 13px 30px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.18s;
}

.adv-org__btn-ghost:hover {
  background: rgba(255, 255, 255, 0.07);
}

.adv-org__benefits {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.adv-org__benefit {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 22px 26px;
  background: rgba(18, 22, 28, 0.75);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  transition: all 0.25s ease;
}

.adv-org__benefit:hover {
  border-color: rgba(90, 175, 154, 0.35);
  background: rgba(24, 30, 38, 0.9);
  transform: translateY(-2px);
}

.adv-org__benefit h4 {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  margin: 0;
  letter-spacing: -0.2px;
}

.adv-org__benefit p {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.6;
  margin: 0;
}

/* =====================================================================
   APP BANNER
   ===================================================================== */
.adv-app {
  background: #0d0e12;
}

.adv-app__inner {
  display: flex;
  align-items: center;
  gap: 80px;
  padding: 90px 80px;
}

@media (max-width: 900px) {
  .adv-app__inner {
    flex-direction: column;
    gap: 48px;
    padding: 60px 28px;
  }

  .adv-app__phone {
    order: -1;
  }
}

.adv-app__text {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.adv-app__eyebrow {
  font-size: 10px;
  letter-spacing: 3px;
  font-weight: 700;
  color: #5AAF9A;
}

.adv-app__title {
  font-size: clamp(28px, 3.5vw, 42px);
  font-weight: 900;
  color: #fff;
  line-height: 1.12;
}

.adv-app__sub {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.55);
  line-height: 1.65;
  max-width: 420px;
}

.adv-app__badges {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
}

.adv-app__badge {
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 14px;
  padding: 10px 20px;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
}

.adv-app__badge:hover {
  background: rgba(90, 175, 154, 0.1);
  border-color: rgba(90, 175, 154, 0.35);
}

.adv-app__badge-icon {
  font-size: 26px;
}

.adv-app__badge-txt .adv-app__badge-sub {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.5);
}

.adv-app__badge-txt .adv-app__badge-name {
  font-size: 14px;
  font-weight: 700;
  color: #fff;
}

/* CSS phone mockup */
.adv-app__phone {
  flex-shrink: 0;
  width: 220px;
  height: 420px;
  background: #111;
  border-radius: 36px;
  border: 3px solid rgba(255, 255, 255, 0.12);
  position: relative;
  overflow: hidden;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.6), inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

.adv-app__phone::before {
  content: '';
  position: absolute;
  top: 14px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 6px;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 6px;
}

.adv-app__phone::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(160deg, rgba(90, 175, 154, 0.15) 0%, rgba(0, 229, 200, 0.06) 60%, transparent 100%);
  pointer-events: none;
}

.adv-app__phone-inner {
  position: absolute;
  inset: 36px 12px 20px;
  border-radius: 20px;
  background: linear-gradient(180deg, #0e2010 0%, #080e06 100%);
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px;
  overflow: hidden;
}

.adv-app__phone-bar {
  height: 8px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
}

.adv-app__phone-bar--gold {
  background: rgba(90, 175, 154, 0.35);
  width: 60%;
}

.adv-app__phone-card {
  height: 72px;
  border-radius: 10px;
  background: linear-gradient(135deg, #0d3028, #0a4a35);
  border: 1px solid rgba(255, 255, 255, 0.07);
  margin-top: 4px;
}

.adv-app__phone-card+.adv-app__phone-card {
  height: 64px;
  background: linear-gradient(135deg, #12102e, #0d1550);
}

/* =====================================================================
   FOOTER
   ===================================================================== */
.adv-footer {
  background: #040903;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.adv-footer__top {
  display: grid;
  grid-template-columns: 1.4fr repeat(4, 1fr);
  gap: 48px;
  padding: 72px 80px 56px;
}

@media (max-width: 1000px) {
  .adv-footer__top {
    grid-template-columns: 1fr 1fr;
    gap: 36px;
    padding: 48px 28px 40px;
  }
}

@media (max-width: 540px) {
  .adv-footer__top {
    grid-template-columns: 1fr;
  }
}

.adv-footer__brand {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.adv-footer__logo {
  font-size: 20px;
  font-weight: 900;
  color: #fff;
}

.adv-footer__tagline {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.45);
  line-height: 1.65;
  max-width: 240px;
}

.adv-footer__socials {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.adv-footer__social {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  cursor: pointer;
  transition: background 0.18s, border-color 0.18s;
}

.adv-footer__social:hover {
  background: rgba(90, 175, 154, 0.15);
  border-color: rgba(90, 175, 154, 0.35);
}

/* Newsletter */
.adv-footer__nl-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.45);
  margin-bottom: 8px;
}

.adv-footer__newsletter {
  display: flex;
  border-radius: 26px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.adv-footer__newsletter input {
  flex: 1 1;
  background: rgba(255, 255, 255, 0.05);
  border: none;
  outline: none;
  color: #fff;
  font-size: 13px;
  padding: 10px 16px;
}

.adv-footer__newsletter input::placeholder {
  color: rgba(255, 255, 255, 0.35);
}

.adv-footer__newsletter button {
  background: #5AAF9A;
  border: none;
  padding: 10px 18px;
  font-size: 12px;
  font-weight: 700;
  color: #080e06;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.18s;
}

.adv-footer__newsletter button:hover {
  opacity: 0.88;
}

/* Columns */
.adv-footer__col {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.adv-footer__col-title {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.5px;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 6px;
  text-transform: uppercase;
}

.adv-footer__link {
  font-size: 13.5px;
  color: rgba(255, 255, 255, 0.55);
  text-decoration: none;
  cursor: pointer;
  transition: color 0.18s;
  background: none;
  border: none;
  text-align: left;
  font-family: inherit;
}

.adv-footer__link:hover {
  color: #5AAF9A;
}

/* Bottom bar */
.adv-footer__bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 20px 80px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

@media (max-width: 768px) {
  .adv-footer__bottom {
    padding: 20px 28px;
  }
}

.adv-footer__copy {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.35);
}

.adv-footer__payments {
  display: flex;
  align-items: center;
  gap: 8px;
}

.adv-footer__pay {
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 600;
}

/* =====================================================================
   RESPONSIVE — Mobile
   ===================================================================== */
@media (max-width: 768px) {
  .an__links {
    display: none;
  }

  .an__right .an__ghost,
  .an__right .an__cta,
  .an__right .an__search-wrap {
    display: none;
  }

  .an__hamburger {
    display: flex;
  }

  .an {
    padding: 1rem 20px 0.5rem 20px;
  }

  .ah__content {
    padding: 100px 24px 60px;
  }

  .ah__sf {
    flex-direction: column;
    border-radius: 18px;
  }

  .ah__sdiv {
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }

  .ah__sdiv:last-of-type {
    border-bottom: none;
  }

  .ah__sbtn {
    border-radius: 14px;
    margin: 5px;
    padding: 12px 20px;
  }

  .adv-sec {
    padding: 56px 24px;
  }

  .adv-how__row {
    flex-direction: column;
    align-items: center;
  }

  .adv-how__arrow {
    display: none;
  }

  .adv-how__step {
    padding: 0 0 32px;
  }

  .adv-up__right {
    display: none;
  }

  .adv-up__item {
    gap: 14px;
    padding: 14px 16px;
  }
}

/* Dynamic Loading & Service List Adjustments */
.adv-loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}

.adv-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid rgba(90, 175, 154, 0.15);
  border-top-color: #5AAF9A;
  border-radius: 50%;
  animation: adv-spin 0.9s linear infinite;
}

@keyframes adv-spin {
  to { transform: rotate(360deg); }
}

.adv-up__thumbnail-box {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
}

.adv-up__thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Make booking cursor interactive */
.adv-ev-card {
  cursor: pointer;
}

/* Filter Pills on Adventure Page */
.adv-filter-pills {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-bottom: 36px;
}

.adv-filter-pill {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 8px 24px;
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  transition: all 0.25s ease;
}

.adv-filter-pill:hover {
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  border-color: rgba(255, 255, 255, 0.2);
}

.adv-filter-pill.active {
  background: #5AAF9A;
  color: #080e06;
  border-color: #5AAF9A;
  box-shadow: 0 4px 16px rgba(90, 175, 154, 0.35);
}

/* No matches found alert */
.adv-no-matches {
  text-align: center;
  padding: 64px 24px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px dashed rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  max-width: 600px;
  margin: 0 auto;
}

.adv-no-matches h3 {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 8px;
}

.adv-no-matches p {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.6;
}

/* Grid Integrated Search Form Styling */
.adv-grid-search {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 540px;
  margin: 0 auto 36px auto;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 28px;
  padding: 6px;
}

.adv-grid-search__field {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
  background: transparent;
  border: none;
  padding: 6px 16px;
  width: 100%;
}

.adv-grid-search__field span {
  font-size: 14px;
}

.adv-grid-search__field input {
  background: transparent;
  border: none;
  color: #fff;
  font-size: 14px;
  outline: none;
  width: 100%;
}

.adv-grid-search__field input::placeholder {
  color: rgba(255, 255, 255, 0.4);
}

.adv-grid-search__date {
  color-scheme: dark;
}

/* =====================================================================
   HOW IT WORKS TABS
   ===================================================================== */
.adv-how-tabs {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 40px;
}

.adv-how-tab {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 24px;
  padding: 10px 28px;
  font-size: 14px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  outline: none;
}

.adv-how-tab:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  border-color: rgba(255, 255, 255, 0.15);
}

.adv-how-tab.active {
  background: #5AAF9A;
  color: #080e06;
  border-color: #5AAF9A;
  box-shadow: 0 6px 20px rgba(90, 175, 154, 0.35);
}

.adv-how__step .adv-how__num {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 2px;
  color: #5AAF9A;
  background: rgba(90, 175, 154, 0.12);
  border: 1px solid rgba(90, 175, 154, 0.25);
  border-radius: 20px;
  padding: 3px 10px;
  margin-top: 4px;
}

/* =====================================================================
   PLATFORM POWERHOUSE SHOWCASE
   ===================================================================== */
.adv-powerhouse {
  background: #060b04; /* Alternate background */
}

/* Glassmorphic card styling */
.glass-card {
  background: rgba(14, 27, 27, 0.65);
  border: 1.5px solid rgba(90, 175, 154, 0.18);
  border-radius: 24px;
  padding: 32px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4),
              inset 0 0 15px rgba(255, 255, 255, 0.02);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
}

.fade-in {
  animation: phFadeIn 0.5s ease-out forwards;
}

@keyframes phFadeIn {
  from { opacity: 0; transform: translateY(15px); }
  to { opacity: 1; transform: translateY(0); }
}

/* =====================================================================
   AMALGAMATE FINANCIALS & FULL TRANSPARENCY SHOWCASE
   ===================================================================== */
.ph-financials-metrics {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  max-width: 1200px;
  margin: 0 auto 36px auto;
}

@media (max-width: 1024px) {
  .ph-financials-metrics {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .ph-financials-metrics {
    grid-template-columns: 1fr;
  }
}

.ph-metric-card {
  background: rgba(255, 255, 255, 0.025);
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 18px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: left;
  transition: transform 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease;
}

.ph-metric-card:hover {
  transform: translateY(-3px);
  border-color: rgba(90, 175, 154, 0.35);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.ph-metric-card__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.ph-metric-card__icon {
  font-size: 24px;
}

.ph-metric-badge {
  font-size: 11px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 12px;
  letter-spacing: 0.5px;
}

.badge--green {
  background: rgba(40, 167, 69, 0.15);
  color: #28a745;
  border: 1px solid rgba(40, 167, 69, 0.3);
}

.badge--amber {
  background: rgba(255, 193, 7, 0.15);
  color: #ffc107;
  border: 1px solid rgba(255, 193, 7, 0.3);
}

.badge--teal {
  background: rgba(90, 175, 154, 0.15);
  color: #5AAF9A;
  border: 1px solid rgba(90, 175, 154, 0.3);
}

.badge--blue {
  background: rgba(54, 162, 235, 0.15);
  color: #36a2eb;
  border: 1px solid rgba(54, 162, 235, 0.3);
}

.ph-metric-lbl {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: rgba(255, 255, 255, 0.5);
}

.ph-metric-val {
  font-size: 26px;
  font-weight: 800;
  letter-spacing: -0.5px;
  margin: 2px 0;
}

.ph-metric-card--funds .ph-metric-val { color: #5AAF9A; }
.ph-metric-card--costs .ph-metric-val { color: #ffc107; }
.ph-metric-card--facilitations .ph-metric-val { color: #28a745; }
.ph-metric-card--resources .ph-metric-val { color: #36a2eb; }

.ph-metric-sub {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.45);
  line-height: 1.4;
}

/* ── Database Box ── */
.ph-database-box {
  max-width: 1200px;
  margin: 0 auto;
  background: rgba(14, 22, 14, 0.7);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 24px;
  padding: 32px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.45);
}

.ph-db-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
  text-align: left;
}

.ph-db-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 6px;
}

.ph-db-title-row h3 {
  font-size: 22px;
  font-weight: 800;
  color: #fff;
}

.ph-db-verified-badge {
  font-size: 11px;
  font-weight: 700;
  background: rgba(90, 175, 154, 0.15);
  color: #5AAF9A;
  border: 1px solid rgba(90, 175, 154, 0.3);
  padding: 3px 12px;
  border-radius: 20px;
}

.ph-db-subtitle {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.55);
}

.ph-db-stats-pill {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 6px 16px;
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.75);
}

/* Search & Dropdown Controls */
.ph-db-controls {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.ph-db-search {
  flex: 1 1;
  min-width: 280px;
  position: relative;
  display: flex;
  align-items: center;
}

.ph-db-search-icon {
  position: absolute;
  left: 16px;
  font-size: 15px;
  opacity: 0.6;
  pointer-events: none;
}

.ph-db-search input {
  width: 100%;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 50px;
  padding: 12px 40px 12px 44px;
  font-size: 13.5px;
  color: #fff;
  outline: none;
  transition: border-color 0.2s ease;
}

.ph-db-search input:focus {
  border-color: rgba(90, 175, 154, 0.6);
}

.ph-db-clear-btn {
  position: absolute;
  right: 14px;
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  font-size: 13px;
}

.ph-db-dropdown-wrap {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 240px;
}

.ph-db-pin {
  position: absolute;
  left: 16px;
  font-size: 14px;
  pointer-events: none;
}

.ph-db-select {
  width: 100%;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 50px;
  padding: 12px 20px 12px 42px;
  font-size: 13.5px;
  color: #fff;
  outline: none;
  cursor: pointer;
}

.ph-db-select option {
  background: #0d1a0d;
  color: #fff;
}

/* Department Filter Pills */
.ph-dept-pills {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 24px;
}

.ph-dept-pill {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 30px;
  padding: 8px 18px;
  font-size: 12.5px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  transition: all 0.2s ease;
}

.ph-dept-pill:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  border-color: rgba(255, 255, 255, 0.18);
}

.ph-dept-pill.active {
  background: rgba(90, 175, 154, 0.2);
  border-color: #5AAF9A;
  color: #fff;
  box-shadow: 0 4px 14px rgba(90, 175, 154, 0.2);
}

/* Ledger List & Rows */
.ph-ledger-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
  max-height: 480px;
  overflow-y: auto;
  padding-right: 6px;
}

.ph-ledger-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 14px;
  padding: 16px 20px;
  gap: 16px;
  transition: background 0.2s ease, border-color 0.2s ease;
  text-align: left;
}

.ph-ledger-row:hover {
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(90, 175, 154, 0.3);
}

.ph-row-main {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1 1;
  min-width: 0;
}

.ph-row-icon-wrap {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
}

.ph-row-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.ph-row-top {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.ph-dept-badge {
  font-size: 10px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.dept-healthcare {
  background: rgba(0, 209, 178, 0.15);
  color: #00d1b2;
  border: 1px solid rgba(0, 209, 178, 0.25);
}

.dept-environmental-protection {
  background: rgba(40, 167, 69, 0.15);
  color: #28a745;
  border: 1px solid rgba(40, 167, 69, 0.25);
}

.dept-human-protection {
  background: rgba(255, 159, 67, 0.15);
  color: #ff9f43;
  border: 1px solid rgba(255, 159, 67, 0.25);
}

.dept-food-supply {
  background: rgba(255, 205, 86, 0.15);
  color: #ffcd56;
  border: 1px solid rgba(255, 205, 86, 0.25);
}

.ph-row-location {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
}

.ph-row-id {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.35);
  font-family: monospace;
}

.ph-row-initiative {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  margin: 2px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 768px) {
  .ph-row-initiative {
    white-space: normal;
  }
  .ph-ledger-row {
    flex-direction: column;
    align-items: flex-start;
  }
  .ph-row-financials {
    align-self: flex-end;
  }
}

.ph-row-meta {
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.45);
  flex-wrap: wrap;
}

.ph-row-audit {
  color: #5AAF9A;
  font-weight: 500;
}

.ph-row-financials {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  flex-shrink: 0;
}

.ph-row-amount {
  font-size: 18px;
  font-weight: 800;
  color: #5AAF9A;
  letter-spacing: -0.3px;
}

.ph-row-badge-disbursed {
  font-size: 10px;
  font-weight: 600;
  background: rgba(90, 175, 154, 0.12);
  color: #5AAF9A;
  border: 1px solid rgba(90, 175, 154, 0.25);
  padding: 2px 8px;
  border-radius: 4px;
}

/* Empty state */
.ph-ledger-empty {
  text-align: center;
  padding: 48px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: rgba(255, 255, 255, 0.6);
}

.ph-ledger-empty h4 {
  color: #fff;
  font-size: 16px;
}

.ph-reset-filters-btn {
  margin-top: 8px;
  background: rgba(90, 175, 154, 0.15);
  border: 1px solid #5AAF9A;
  color: #fff;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;
}

.ph-reset-filters-btn:hover {
  background: rgba(90, 175, 154, 0.3);
}

/* Database Footer */
.ph-db-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding-top: 20px;
  flex-wrap: wrap;
  gap: 16px;
}

.ph-db-footer-left {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.45);
  max-width: 650px;
  text-align: left;
}

.ph-db-footer-right {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.ph-db-subtotal-lbl {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: rgba(255, 255, 255, 0.5);
}

.ph-db-subtotal-val {
  font-size: 20px;
  font-weight: 800;
  color: #5AAF9A;
}

/* =====================================================================
   FACILITATE PILLARS STYLES
   ===================================================================== */
.fac-pillars {
  padding: 88px clamp(24px, 6vw, 100px);
  background: #0d0e12;
  position: relative;
}

.fac-pillars__eyebrow {
  display: inline-block;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 2px;
  color: #5AAF9A;
  background: rgba(90, 175, 154, 0.12);
  border: 1px solid rgba(90, 175, 154, 0.28);
  border-radius: 20px;
  padding: 5px 14px;
  margin-bottom: 12px;
  text-align: center;
  text-transform: uppercase;
}

.fac-pillars__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 24px;
  margin-top: 44px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.fac-pillar-card {
  display: flex;
  flex-direction: column;
  padding: 32px 28px;
  background: rgba(18, 22, 28, 0.75);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
  transition: transform 0.22s ease, border-color 0.22s ease, box-shadow 0.22s ease;
  position: relative;
}

.fac-pillar-card:hover {
  transform: translateY(-5px);
  border-color: rgba(90, 175, 154, 0.45);
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.5), 0 0 24px rgba(90, 175, 154, 0.14);
}

.fac-pillar-card__title {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 10px;
  line-height: 1.35;
  letter-spacing: -0.2px;
}

.fac-pillar-card__desc {
  font-size: 13.5px;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.6;
  margin-bottom: 24px;
  flex-grow: 1;
}

.fac-pillar-card__btn {
  background: rgba(90, 175, 154, 0.12);
  border: 1px solid rgba(90, 175, 154, 0.4);
  color: #5AAF9A;
  font-size: 12px;
  font-weight: 700;
  padding: 8px 18px;
  border-radius: 999px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  align-self: flex-start;
  transition: all 0.2s ease;
}

.fac-pillar-card__btn span {
  transition: transform 0.2s ease;
}

.fac-pillar-card__btn:hover {
  background: #5AAF9A;
  color: #0d0e12;
  border-color: #5AAF9A;
  box-shadow: 0 4px 14px rgba(90, 175, 154, 0.35);
}

.fac-pillar-card__btn:hover span {
  transform: translateX(3px);
}

`, "",{"version":3,"sources":["webpack://./src/Pages/AdventurePage/AdventurePage.css"],"names":[],"mappings":"AAAA;;0DAE0D;;AAE1D,mCAAmC;AACnC;;;EAGE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,8EAA8E;EAC9E,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;0EAE0E;;AAE1E;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,kCAAkC;EAClC,gFAAgF;EAChF,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA,gBAAgB;AAChB;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,0DAA0D;EAC1D,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,qCAAqC;EACrC,WAAW;AACb;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,2BAA2B;EAC3B,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,qBAAqB;EACrB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,uBAAuB;EACvB,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,qCAAqC;AACvC;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;0EAE0E;AAC1E;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;qEAEmE;AACrE;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,2BAA2B;EAC3B,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;;0EAE0E;AAC1E;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,oCAAoC;EACpC,yCAAyC;EACzC,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;0EAE0E;AAC1E;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,iEAAiE;AACnE;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;;0EAE0E;AAC1E;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,iEAAiE;EACjE,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;;0EAE0E;AAC1E;EACE,aAAa;EACb,uBAAuB;EACvB,MAAM;AACR;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;;0EAE0E;AAC1E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;;0EAE0E;AAC1E;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;;0EAE0E;AAC1E;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;AACF;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,2BAA2B;EAC3B,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,SAAS;AACX;;AAEA;;0EAE0E;AAC1E;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,mFAAmF;AACrF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,+GAA+G;EAC/G,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,qDAAqD;AACvD;;AAEA;;0EAE0E;AAC1E;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE;IACE,8BAA8B;IAC9B,SAAS;IACT,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA,eAAe;AACf;EACE,eAAe;EACf,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,SAAO;EACP,qCAAqC;EACrC,YAAY;EACZ,aAAa;EACb,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;0EAE0E;AAC1E;EACE;IACE,aAAa;EACf;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,kDAAkD;EACpD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;IACT,kBAAkB;EACpB;AACF;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,oCAAoC;AACpC;EACE,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,4CAA4C;EAC5C,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;0EAE0E;AAC1E;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,kDAAkD;EAClD,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;0EAE0E;AAC1E;EACE,mBAAmB,EAAE,yBAAyB;AAChD;;AAEA,8BAA8B;AAC9B;EACE,kCAAkC;EAClC,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;EACb;sDACoD;EACpD,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;;0EAE0E;AAC1E;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;AACf;;AAEA,wCAAwC,cAAc,EAAE;AACxD,wCAAwC,cAAc,EAAE;AACxD,gDAAgD,cAAc,EAAE;AAChE,4CAA4C,cAAc,EAAE;;AAE5D;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,cAAc;EACd,iCAAiC;EACjC,2BAA2B;EAC3B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,yCAAyC;EACzC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,4BAA4B;EAC5B,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,4BAA4B;EAC5B,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,WAAW;EACX,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,wDAAwD;EACxD,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,+CAA+C;EAC/C,iBAAiB;EACjB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;0EAE0E;AAC1E;EACE,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,gFAAgF;EAChF,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,6EAA6E;AAC/E;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["/* =====================================================\n   AdventurePage.css - Full Adventure Landing Page\n   ===================================================== */\n\n/* -------- Reset / base -------- */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n/* -------- Page shell -------- */\n.adv-page {\n  min-height: 100vh;\n  background: #0d0e12;\n  color: #fff;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  overflow-x: hidden;\n}\n\n.c-green {\n  color: #5AAF9A;\n}\n\n/* =====================================================================\n   NAVBAR\n   ===================================================================== */\n\n.an {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 900;\n  display: flex;\n  align-items: center;\n  gap: 0;\n  padding: 1.25rem 32px 0.75rem 32px;\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.55) 0%, transparent 100%);\n  transition: background 0.35s, box-shadow 0.35s;\n}\n\n.an--scrolled {\n  background: rgba(6, 12, 4, 0.88);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  box-shadow: 0 2px 24px rgba(0, 0, 0, 0.4);\n}\n\n/* Back to Hub */\n.an__back-hub {\n  background: transparent;\n  border: 1px solid rgba(90, 175, 154, 0.55);\n  border-radius: 20px;\n  padding: 6px 14px;\n  font-size: 11.5px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  color: #5AAF9A;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.2s, border-color 0.2s, color 0.2s;\n  flex-shrink: 0;\n}\n\n.an__back-hub:hover {\n  background: rgba(90, 175, 154, 0.12);\n  border-color: #5AAF9A;\n  color: #5AAF9A;\n}\n\n.an__logo {\n  display: flex;\n  align-items: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  text-decoration: none;\n  flex-shrink: 0;\n  margin-right: 40px;\n  transition: opacity 0.2s ease, transform 0.2s ease;\n}\n\n.an__logo:hover {\n  opacity: 0.92;\n  transform: translateY(-1px);\n}\n\n.an__logo-img {\n  height: clamp(42px, 3.2vw, 56px);\n  width: auto;\n  object-fit: contain;\n  display: block;\n}\n\n/* Link list */\n.an__links {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  list-style: none;\n  flex: 1;\n}\n\n.an__item {\n  position: relative;\n}\n\n.an__link {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 8px 14px;\n  font-size: 13.5px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.82);\n  text-decoration: none;\n  border-radius: 8px;\n  white-space: nowrap;\n  transition: background 0.18s, color 0.18s;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.an__link:hover,\n.an__link:focus-visible {\n  background: rgba(255, 255, 255, 0.07);\n  color: #fff;\n}\n\n/* Dropdown */\n.an__dd {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  min-width: 180px;\n  background: #0e1c0b;\n  border: 1px solid rgba(255, 255, 255, 0.09);\n  border-radius: 12px;\n  padding: 6px;\n  opacity: 0;\n  pointer-events: none;\n  transform: translateY(-6px);\n  transition: opacity 0.2s, transform 0.2s;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);\n}\n\n.an__item:hover .an__dd {\n  opacity: 1;\n  pointer-events: all;\n  transform: translateY(0);\n}\n\n.an__dd-item {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  padding: 9px 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.8);\n  text-decoration: none;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.an__dd-item:hover {\n  background: rgba(255, 255, 255, 0.07);\n  color: #fff;\n}\n\n/* Right cluster */\n.an__right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n  flex-shrink: 0;\n}\n\n.an__ghost {\n  padding: 8px 18px;\n  font-size: 13px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.85);\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.22);\n  border-radius: 22px;\n  cursor: pointer;\n  transition: background 0.18s, border-color 0.18s;\n  white-space: nowrap;\n}\n\n.an__ghost:hover {\n  background: rgba(255, 255, 255, 0.07);\n  border-color: rgba(255, 255, 255, 0.38);\n}\n\n.an__cta {\n  padding: 8px 20px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #080e06;\n  background: #5AAF9A;\n  border: none;\n  border-radius: 22px;\n  cursor: pointer;\n  transition: opacity 0.18s;\n  white-space: nowrap;\n}\n\n.an__cta:hover {\n  opacity: 0.88;\n}\n\n/* Cart */\n.an__cart {\n  position: relative;\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 4px 8px;\n  line-height: 1;\n}\n\n.an__badge {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #5AAF9A;\n  color: #000;\n  font-size: 9px;\n  font-weight: 800;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Search */\n.an__search-wrap {\n  position: relative;\n}\n\n.an__search-input {\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  color: #fff;\n  padding: 7px 16px;\n  font-size: 13px;\n  outline: none;\n  width: 180px;\n  transition: width 0.3s, border-color 0.2s;\n}\n\n.an__search-input::placeholder {\n  color: rgba(255, 255, 255, 0.4);\n}\n\n.an__search-input:focus {\n  width: 240px;\n  border-color: rgba(90, 175, 154, 0.5);\n}\n\n/* Hamburger */\n.an__hamburger {\n  display: none;\n  flex-direction: column;\n  gap: 5px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 6px;\n  margin-left: 8px;\n}\n\n.an__hamburger span {\n  display: block;\n  width: 22px;\n  height: 2px;\n  background: #fff;\n  border-radius: 2px;\n  transition: transform 0.25s, opacity 0.25s;\n}\n\n/* Overlay + Drawer */\n.an__overlay {\n  display: none;\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  z-index: 800;\n}\n\n.an__overlay--open {\n  display: block;\n}\n\n.an__drawer {\n  position: fixed;\n  top: 0;\n  left: -280px;\n  width: 280px;\n  height: 100%;\n  background: #0c1a09;\n  z-index: 850;\n  padding: 80px 24px 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  transition: left 0.3s cubic-bezier(.4, 0, .2, 1);\n  overflow-y: auto;\n}\n\n.an__drawer--open {\n  left: 0;\n}\n\n.an__drawer .an__link {\n  width: 100%;\n  font-size: 15px;\n  padding: 12px 16px;\n}\n\n.an__drawer .an__ghost,\n.an__drawer .an__cta {\n  width: 100%;\n  text-align: center;\n  margin-top: 8px;\n  padding: 12px 20px;\n  font-size: 14px;\n}\n\n/* =====================================================================\n   HERO\n   ===================================================================== */\n.ah {\n  position: relative;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n}\n\n.ah__bg {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center top;\n}\n\n.ah__overlay {\n  position: absolute;\n  inset: 0;\n  background:\n    linear-gradient(to right, rgba(0, 0, 0, 0.72) 40%, rgba(0, 0, 0, 0.22) 100%),\n    linear-gradient(to top, rgba(8, 14, 6, 0.95) 0%, transparent 40%);\n}\n\n.ah__content {\n  position: relative;\n  z-index: 2;\n  padding: 130px 80px 80px;\n  max-width: 820px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.ah__eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 11px;\n  letter-spacing: 3px;\n  font-weight: 700;\n  color: #5AAF9A;\n  background: rgba(90, 175, 154, 0.12);\n  border: 1px solid rgba(90, 175, 154, 0.28);\n  border-radius: 20px;\n  padding: 5px 14px;\n  width: fit-content;\n}\n\n.ah__title {\n  font-size: clamp(34px, 4.8vw, 62px);\n  font-weight: 900;\n  line-height: 1.12;\n  letter-spacing: -0.5px;\n  color: #fff;\n}\n\n.ah__desc {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.ah__sub {\n  font-size: 16px;\n  color: rgba(255, 255, 255, 0.78);\n  line-height: 1.68;\n}\n\n/* Search bar */\n.ah__search {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.ah__sf {\n  display: flex;\n  background: rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 50px;\n  overflow: hidden;\n  transition: border-color 0.25s;\n}\n\n.ah__sf:focus-within {\n  border-color: rgba(90, 175, 154, 0.55);\n}\n\n.ah__sdiv {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 20px;\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.ah__sdiv:last-of-type {\n  border-right: none;\n}\n\n.ah__sdiv input,\n.ah__sdiv select {\n  background: none;\n  border: none;\n  outline: none;\n  color: #fff;\n  font-size: 14px;\n  width: 100%;\n  height: 52px;\n}\n\n.ah__sdiv input::placeholder {\n  color: rgba(255, 255, 255, 0.45);\n}\n\n.ah__sdiv select option {\n  background: #0c1a09;\n  color: #fff;\n}\n\n.ah__sdiv .ah__icon {\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\n.ah__sbtn {\n  background: #5AAF9A;\n  border: none;\n  border-radius: 50px;\n  margin: 5px;\n  padding: 0 28px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #080e06;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: opacity 0.2s;\n}\n\n.ah__sbtn:hover {\n  opacity: 0.88;\n}\n\n.ah__date {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.45);\n  padding-left: 8px;\n}\n\n/* Social proof */\n.ah__proof {\n  display: flex;\n  align-items: center;\n  gap: 28px;\n  flex-wrap: wrap;\n  margin-top: 12px;\n  padding-top: 20px;\n  border-top: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.ah__proof-item {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.ah__proof-item strong {\n  font-size: 20px;\n  font-weight: 800;\n  color: #5AAF9A;\n  letter-spacing: -0.3px;\n}\n\n.ah__proof-item span {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.65);\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.ah__proof-sep {\n  width: 1px;\n  height: 32px;\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.ah__avatars {\n  display: flex;\n}\n\n.ah__avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  border: 2px solid #080e06;\n  font-size: 11px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: -10px;\n  color: #080e06;\n}\n\n.ah__avatars .ah__avatar:first-child {\n  margin-left: 0;\n}\n\n.ah__proof-txt {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.6);\n  line-height: 1.4;\n}\n\n.ah__proof-txt strong {\n  color: #fff;\n}\n\n/* =====================================================================\n   SHARED SECTION SHELL\n   ===================================================================== */\n.adv-sec {\n  padding: 90px 80px;\n}\n\n.adv-sec--alt {\n  background: #090a0e;\n}\n\n.adv-sec__hdr {\n  text-align: center;\n  margin-bottom: 52px;\n}\n\n.sec-step-badge {\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  color: #5AAF9A;\n  background: rgba(90, 175, 154, 0.12);\n  border: 1px solid rgba(90, 175, 154, 0.3);\n  border-radius: 20px;\n  padding: 5px 14px;\n  margin-bottom: 14px;\n}\n\n.adv-sec__eyebrow {\n  display: inline-block;\n  font-size: 10px;\n  letter-spacing: 3px;\n  font-weight: 700;\n  color: #5AAF9A;\n  margin-bottom: 12px;\n}\n\n.adv-sec__title {\n  font-size: clamp(28px, 4vw, 42px);\n  font-weight: 900;\n  color: #fff;\n  margin-bottom: 10px;\n}\n\n.adv-sec__sub {\n  font-size: 16px;\n  color: rgba(255, 255, 255, 0.55);\n  max-width: 540px;\n  margin: 0 auto;\n  line-height: 1.65;\n}\n\n/* =====================================================================\n   CATEGORIES\n   ===================================================================== */\n.adv-cats {\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  gap: 16px;\n}\n\n@media (max-width: 1100px) {\n  .adv-cats {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n@media (max-width: 600px) {\n  .adv-cats {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.adv-cat {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  padding: 22px 12px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.07);\n  border-radius: 16px;\n  cursor: pointer;\n  transition: border-color 0.22s, background 0.22s, transform 0.22s;\n}\n\n.adv-cat:hover {\n  border-color: rgba(90, 175, 154, 0.45);\n  background: rgba(90, 175, 154, 0.07);\n  transform: translateY(-3px);\n}\n\n.adv-cat__icon {\n  font-size: 28px;\n  line-height: 1;\n}\n\n.adv-cat__label {\n  font-size: 12px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.75);\n  text-align: center;\n}\n\n/* =====================================================================\n   FEATURED EVENTS GRID\n   ===================================================================== */\n.adv-ev-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n}\n\n@media (max-width: 960px) {\n  .adv-ev-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 580px) {\n  .adv-ev-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.adv-ev-card {\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.07);\n  border-radius: 18px;\n  overflow: hidden;\n  transition: transform 0.25s, border-color 0.25s, box-shadow 0.25s;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n}\n\n.adv-ev-card:hover {\n  transform: translateY(-4px);\n  border-color: rgba(90, 175, 154, 0.3);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);\n}\n\n.adv-ev-card__img {\n  height: 180px;\n  display: flex;\n  align-items: flex-end;\n  padding: 12px 14px;\n  position: relative;\n}\n\n.adv-ev-card__badge {\n  font-size: 10px;\n  font-weight: 700;\n  background: rgba(0, 0, 0, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 20px;\n  padding: 4px 10px;\n  color: #fff;\n  backdrop-filter: blur(6px);\n}\n\n.adv-ev-card__body {\n  padding: 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 1;\n}\n\n.adv-ev-card__name {\n  font-size: 16px;\n  font-weight: 700;\n  color: #fff;\n  line-height: 1.3;\n}\n\n.adv-ev-card__meta {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.5);\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.adv-ev-card__foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: auto;\n  padding-top: 14px;\n  border-top: 1px solid rgba(255, 255, 255, 0.07);\n}\n\n.adv-ev-card__price {\n  font-size: 14px;\n  font-weight: 700;\n  color: #5AAF9A;\n}\n\n.adv-ev-card__btn {\n  background: #5AAF9A;\n  border: none;\n  border-radius: 20px;\n  padding: 7px 18px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #080e06;\n  cursor: pointer;\n  transition: opacity 0.18s;\n}\n\n.adv-ev-card__btn:hover {\n  opacity: 0.85;\n}\n\n/* =====================================================================\n   HOW IT WORKS\n   ===================================================================== */\n.adv-how__row {\n  display: flex;\n  align-items: flex-start;\n  gap: 0;\n}\n\n.adv-how__step {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 16px;\n  padding: 0 24px;\n}\n\n.adv-how__num {\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 2px;\n  color: rgba(90, 175, 154, 0.6);\n}\n\n.adv-how__icon {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  background: rgba(90, 175, 154, 0.1);\n  border: 2px solid rgba(90, 175, 154, 0.22);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 30px;\n}\n\n.adv-how__step h3 {\n  font-size: 18px;\n  font-weight: 800;\n  color: #fff;\n}\n\n.adv-how__step p {\n  font-size: 13.5px;\n  color: rgba(255, 255, 255, 0.55);\n  line-height: 1.65;\n  max-width: 260px;\n}\n\n.adv-how__arrow {\n  display: flex;\n  align-items: center;\n  padding-top: 36px;\n  color: rgba(90, 175, 154, 0.4);\n  font-size: 24px;\n  flex-shrink: 0;\n}\n\n/* =====================================================================\n   UPCOMING EVENTS\n   ===================================================================== */\n.adv-up__list {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.adv-up__item {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.07);\n  border-radius: 14px;\n  padding: 18px 24px;\n  cursor: pointer;\n  transition: border-color 0.22s, background 0.22s;\n}\n\n.adv-up__item:hover {\n  border-color: rgba(90, 175, 154, 0.3);\n  background: rgba(90, 175, 154, 0.04);\n}\n\n.adv-up__datebox {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 52px;\n  height: 52px;\n  background: rgba(90, 175, 154, 0.12);\n  border: 1px solid rgba(90, 175, 154, 0.25);\n  border-radius: 10px;\n  flex-shrink: 0;\n}\n\n.adv-up__mon {\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  color: #5AAF9A;\n  text-transform: uppercase;\n}\n\n.adv-up__day {\n  font-size: 20px;\n  font-weight: 900;\n  color: #fff;\n  line-height: 1;\n}\n\n.adv-up__info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.adv-up__name {\n  font-size: 15px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.adv-up__detail {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.adv-up__right {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin-left: auto;\n  flex-shrink: 0;\n}\n\n.adv-up__cat {\n  font-size: 11px;\n  font-weight: 700;\n  padding: 4px 12px;\n  border-radius: 20px;\n  background: rgba(90, 175, 154, 0.12);\n  color: #5AAF9A;\n}\n\n.adv-up__price {\n  font-size: 14px;\n  font-weight: 700;\n  color: #5AAF9A;\n  min-width: 52px;\n  text-align: right;\n}\n\n.adv-up__btn {\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 20px;\n  padding: 7px 18px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #fff;\n  cursor: pointer;\n  transition: background 0.18s;\n}\n\n.adv-up__btn:hover {\n  background: rgba(90, 175, 154, 0.18);\n  border-color: rgba(90, 175, 154, 0.4);\n}\n\n/* =====================================================================\n   TESTIMONIALS\n   ===================================================================== */\n.adv-testi__grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n}\n\n@media (max-width: 860px) {\n  .adv-testi__grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.adv-testi__card {\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 18px;\n  padding: 28px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  transition: border-color 0.25s;\n}\n\n.adv-testi__card:hover {\n  border-color: rgba(90, 175, 154, 0.25);\n}\n\n.adv-testi__stars {\n  font-size: 16px;\n  letter-spacing: 2px;\n  color: #5AAF9A;\n}\n\n.adv-testi__text {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.72);\n  line-height: 1.7;\n  flex: 1;\n  font-style: italic;\n}\n\n.adv-testi__author {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding-top: 16px;\n  border-top: 1px solid rgba(255, 255, 255, 0.07);\n}\n\n.adv-testi__avatar {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 800;\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.adv-testi__name {\n  font-size: 14px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.adv-testi__event {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.45);\n}\n\n/* =====================================================================\n   ORGANIZERS\n   ===================================================================== */\n.adv-org {\n  background: #0d0e12;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.adv-org__inner {\n  display: flex;\n  align-items: center;\n  gap: 80px;\n  padding: 90px 80px;\n}\n\n@media (max-width: 900px) {\n  .adv-org__inner {\n    flex-direction: column;\n    gap: 48px;\n    padding: 60px 28px;\n  }\n}\n\n.adv-org__left {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.adv-org__eyebrow {\n  font-size: 10px;\n  letter-spacing: 3px;\n  font-weight: 700;\n  color: #5AAF9A;\n}\n\n.adv-org__title {\n  font-size: clamp(28px, 3.5vw, 42px);\n  font-weight: 900;\n  color: #fff;\n  line-height: 1.12;\n}\n\n.adv-org__sub {\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.55);\n  line-height: 1.7;\n  max-width: 440px;\n}\n\n.adv-org__cta {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.adv-org__btn-primary {\n  background: #5AAF9A;\n  color: #080e06;\n  border: none;\n  border-radius: 26px;\n  padding: 13px 30px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: opacity 0.18s;\n}\n\n.adv-org__btn-primary:hover {\n  opacity: 0.88;\n}\n\n.adv-org__btn-ghost {\n  background: transparent;\n  color: #fff;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  border-radius: 26px;\n  padding: 13px 30px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.18s;\n}\n\n.adv-org__btn-ghost:hover {\n  background: rgba(255, 255, 255, 0.07);\n}\n\n.adv-org__benefits {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.adv-org__benefit {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 22px 26px;\n  background: rgba(18, 22, 28, 0.75);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 16px;\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  transition: all 0.25s ease;\n}\n\n.adv-org__benefit:hover {\n  border-color: rgba(90, 175, 154, 0.35);\n  background: rgba(24, 30, 38, 0.9);\n  transform: translateY(-2px);\n}\n\n.adv-org__benefit h4 {\n  font-size: 16px;\n  font-weight: 700;\n  color: #fff;\n  margin: 0;\n  letter-spacing: -0.2px;\n}\n\n.adv-org__benefit p {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.6);\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* =====================================================================\n   APP BANNER\n   ===================================================================== */\n.adv-app {\n  background: #0d0e12;\n}\n\n.adv-app__inner {\n  display: flex;\n  align-items: center;\n  gap: 80px;\n  padding: 90px 80px;\n}\n\n@media (max-width: 900px) {\n  .adv-app__inner {\n    flex-direction: column;\n    gap: 48px;\n    padding: 60px 28px;\n  }\n\n  .adv-app__phone {\n    order: -1;\n  }\n}\n\n.adv-app__text {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.adv-app__eyebrow {\n  font-size: 10px;\n  letter-spacing: 3px;\n  font-weight: 700;\n  color: #5AAF9A;\n}\n\n.adv-app__title {\n  font-size: clamp(28px, 3.5vw, 42px);\n  font-weight: 900;\n  color: #fff;\n  line-height: 1.12;\n}\n\n.adv-app__sub {\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.55);\n  line-height: 1.65;\n  max-width: 420px;\n}\n\n.adv-app__badges {\n  display: flex;\n  gap: 14px;\n  flex-wrap: wrap;\n}\n\n.adv-app__badge {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 14px;\n  padding: 10px 20px;\n  cursor: pointer;\n  transition: background 0.2s, border-color 0.2s;\n}\n\n.adv-app__badge:hover {\n  background: rgba(90, 175, 154, 0.1);\n  border-color: rgba(90, 175, 154, 0.35);\n}\n\n.adv-app__badge-icon {\n  font-size: 26px;\n}\n\n.adv-app__badge-txt .adv-app__badge-sub {\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.adv-app__badge-txt .adv-app__badge-name {\n  font-size: 14px;\n  font-weight: 700;\n  color: #fff;\n}\n\n/* CSS phone mockup */\n.adv-app__phone {\n  flex-shrink: 0;\n  width: 220px;\n  height: 420px;\n  background: #111;\n  border-radius: 36px;\n  border: 3px solid rgba(255, 255, 255, 0.12);\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.6), inset 0 1px 0 rgba(255, 255, 255, 0.08);\n}\n\n.adv-app__phone::before {\n  content: '';\n  position: absolute;\n  top: 14px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 60px;\n  height: 6px;\n  background: rgba(255, 255, 255, 0.12);\n  border-radius: 6px;\n}\n\n.adv-app__phone::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(160deg, rgba(90, 175, 154, 0.15) 0%, rgba(0, 229, 200, 0.06) 60%, transparent 100%);\n  pointer-events: none;\n}\n\n.adv-app__phone-inner {\n  position: absolute;\n  inset: 36px 12px 20px;\n  border-radius: 20px;\n  background: linear-gradient(180deg, #0e2010 0%, #080e06 100%);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 14px;\n  overflow: hidden;\n}\n\n.adv-app__phone-bar {\n  height: 8px;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.adv-app__phone-bar--gold {\n  background: rgba(90, 175, 154, 0.35);\n  width: 60%;\n}\n\n.adv-app__phone-card {\n  height: 72px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #0d3028, #0a4a35);\n  border: 1px solid rgba(255, 255, 255, 0.07);\n  margin-top: 4px;\n}\n\n.adv-app__phone-card+.adv-app__phone-card {\n  height: 64px;\n  background: linear-gradient(135deg, #12102e, #0d1550);\n}\n\n/* =====================================================================\n   FOOTER\n   ===================================================================== */\n.adv-footer {\n  background: #040903;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.adv-footer__top {\n  display: grid;\n  grid-template-columns: 1.4fr repeat(4, 1fr);\n  gap: 48px;\n  padding: 72px 80px 56px;\n}\n\n@media (max-width: 1000px) {\n  .adv-footer__top {\n    grid-template-columns: 1fr 1fr;\n    gap: 36px;\n    padding: 48px 28px 40px;\n  }\n}\n\n@media (max-width: 540px) {\n  .adv-footer__top {\n    grid-template-columns: 1fr;\n  }\n}\n\n.adv-footer__brand {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.adv-footer__logo {\n  font-size: 20px;\n  font-weight: 900;\n  color: #fff;\n}\n\n.adv-footer__tagline {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.45);\n  line-height: 1.65;\n  max-width: 240px;\n}\n\n.adv-footer__socials {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.adv-footer__social {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n  cursor: pointer;\n  transition: background 0.18s, border-color 0.18s;\n}\n\n.adv-footer__social:hover {\n  background: rgba(90, 175, 154, 0.15);\n  border-color: rgba(90, 175, 154, 0.35);\n}\n\n/* Newsletter */\n.adv-footer__nl-label {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.45);\n  margin-bottom: 8px;\n}\n\n.adv-footer__newsletter {\n  display: flex;\n  border-radius: 26px;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.adv-footer__newsletter input {\n  flex: 1;\n  background: rgba(255, 255, 255, 0.05);\n  border: none;\n  outline: none;\n  color: #fff;\n  font-size: 13px;\n  padding: 10px 16px;\n}\n\n.adv-footer__newsletter input::placeholder {\n  color: rgba(255, 255, 255, 0.35);\n}\n\n.adv-footer__newsletter button {\n  background: #5AAF9A;\n  border: none;\n  padding: 10px 18px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #080e06;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: opacity 0.18s;\n}\n\n.adv-footer__newsletter button:hover {\n  opacity: 0.88;\n}\n\n/* Columns */\n.adv-footer__col {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.adv-footer__col-title {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 1.5px;\n  color: rgba(255, 255, 255, 0.5);\n  margin-bottom: 6px;\n  text-transform: uppercase;\n}\n\n.adv-footer__link {\n  font-size: 13.5px;\n  color: rgba(255, 255, 255, 0.55);\n  text-decoration: none;\n  cursor: pointer;\n  transition: color 0.18s;\n  background: none;\n  border: none;\n  text-align: left;\n  font-family: inherit;\n}\n\n.adv-footer__link:hover {\n  color: #5AAF9A;\n}\n\n/* Bottom bar */\n.adv-footer__bottom {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n  padding: 20px 80px;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n@media (max-width: 768px) {\n  .adv-footer__bottom {\n    padding: 20px 28px;\n  }\n}\n\n.adv-footer__copy {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.35);\n}\n\n.adv-footer__payments {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.adv-footer__pay {\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 6px;\n  padding: 4px 10px;\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.5);\n  font-weight: 600;\n}\n\n/* =====================================================================\n   RESPONSIVE — Mobile\n   ===================================================================== */\n@media (max-width: 768px) {\n  .an__links {\n    display: none;\n  }\n\n  .an__right .an__ghost,\n  .an__right .an__cta,\n  .an__right .an__search-wrap {\n    display: none;\n  }\n\n  .an__hamburger {\n    display: flex;\n  }\n\n  .an {\n    padding: 1rem 20px 0.5rem 20px;\n  }\n\n  .ah__content {\n    padding: 100px 24px 60px;\n  }\n\n  .ah__sf {\n    flex-direction: column;\n    border-radius: 18px;\n  }\n\n  .ah__sdiv {\n    border-right: none;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  }\n\n  .ah__sdiv:last-of-type {\n    border-bottom: none;\n  }\n\n  .ah__sbtn {\n    border-radius: 14px;\n    margin: 5px;\n    padding: 12px 20px;\n  }\n\n  .adv-sec {\n    padding: 56px 24px;\n  }\n\n  .adv-how__row {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .adv-how__arrow {\n    display: none;\n  }\n\n  .adv-how__step {\n    padding: 0 0 32px;\n  }\n\n  .adv-up__right {\n    display: none;\n  }\n\n  .adv-up__item {\n    gap: 14px;\n    padding: 14px 16px;\n  }\n}\n\n/* Dynamic Loading & Service List Adjustments */\n.adv-loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n}\n\n.adv-spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid rgba(90, 175, 154, 0.15);\n  border-top-color: #5AAF9A;\n  border-radius: 50%;\n  animation: adv-spin 0.9s linear infinite;\n}\n\n@keyframes adv-spin {\n  to { transform: rotate(360deg); }\n}\n\n.adv-up__thumbnail-box {\n  width: 60px;\n  height: 60px;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.adv-up__thumb-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Make booking cursor interactive */\n.adv-ev-card {\n  cursor: pointer;\n}\n\n/* Filter Pills on Adventure Page */\n.adv-filter-pills {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 36px;\n}\n\n.adv-filter-pill {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  padding: 8px 24px;\n  font-size: 14px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.7);\n  cursor: pointer;\n  transition: all 0.25s ease;\n}\n\n.adv-filter-pill:hover {\n  background: rgba(255, 255, 255, 0.12);\n  color: #fff;\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.adv-filter-pill.active {\n  background: #5AAF9A;\n  color: #080e06;\n  border-color: #5AAF9A;\n  box-shadow: 0 4px 16px rgba(90, 175, 154, 0.35);\n}\n\n/* No matches found alert */\n.adv-no-matches {\n  text-align: center;\n  padding: 64px 24px;\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px dashed rgba(255, 255, 255, 0.08);\n  border-radius: 18px;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.adv-no-matches h3 {\n  font-size: 20px;\n  font-weight: 700;\n  color: #fff;\n  margin-bottom: 8px;\n}\n\n.adv-no-matches p {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.5);\n  line-height: 1.6;\n}\n\n/* Grid Integrated Search Form Styling */\n.adv-grid-search {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-width: 540px;\n  margin: 0 auto 36px auto;\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 28px;\n  padding: 6px;\n}\n\n.adv-grid-search__field {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n  background: transparent;\n  border: none;\n  padding: 6px 16px;\n  width: 100%;\n}\n\n.adv-grid-search__field span {\n  font-size: 14px;\n}\n\n.adv-grid-search__field input {\n  background: transparent;\n  border: none;\n  color: #fff;\n  font-size: 14px;\n  outline: none;\n  width: 100%;\n}\n\n.adv-grid-search__field input::placeholder {\n  color: rgba(255, 255, 255, 0.4);\n}\n\n.adv-grid-search__date {\n  color-scheme: dark;\n}\n\n/* =====================================================================\n   HOW IT WORKS TABS\n   ===================================================================== */\n.adv-how-tabs {\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  margin-bottom: 40px;\n}\n\n.adv-how-tab {\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 24px;\n  padding: 10px 28px;\n  font-size: 14px;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.6);\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n  outline: none;\n}\n\n.adv-how-tab:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n  border-color: rgba(255, 255, 255, 0.15);\n}\n\n.adv-how-tab.active {\n  background: #5AAF9A;\n  color: #080e06;\n  border-color: #5AAF9A;\n  box-shadow: 0 6px 20px rgba(90, 175, 154, 0.35);\n}\n\n.adv-how__step .adv-how__num {\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 2px;\n  color: #5AAF9A;\n  background: rgba(90, 175, 154, 0.12);\n  border: 1px solid rgba(90, 175, 154, 0.25);\n  border-radius: 20px;\n  padding: 3px 10px;\n  margin-top: 4px;\n}\n\n/* =====================================================================\n   PLATFORM POWERHOUSE SHOWCASE\n   ===================================================================== */\n.adv-powerhouse {\n  background: #060b04; /* Alternate background */\n}\n\n/* Glassmorphic card styling */\n.glass-card {\n  background: rgba(14, 27, 27, 0.65);\n  border: 1.5px solid rgba(90, 175, 154, 0.18);\n  border-radius: 24px;\n  padding: 32px;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4),\n              inset 0 0 15px rgba(255, 255, 255, 0.02);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n}\n\n.fade-in {\n  animation: phFadeIn 0.5s ease-out forwards;\n}\n\n@keyframes phFadeIn {\n  from { opacity: 0; transform: translateY(15px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* =====================================================================\n   AMALGAMATE FINANCIALS & FULL TRANSPARENCY SHOWCASE\n   ===================================================================== */\n.ph-financials-metrics {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n  max-width: 1200px;\n  margin: 0 auto 36px auto;\n}\n\n@media (max-width: 1024px) {\n  .ph-financials-metrics {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 600px) {\n  .ph-financials-metrics {\n    grid-template-columns: 1fr;\n  }\n}\n\n.ph-metric-card {\n  background: rgba(255, 255, 255, 0.025);\n  border: 1px solid rgba(255, 255, 255, 0.07);\n  border-radius: 18px;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  text-align: left;\n  transition: transform 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease;\n}\n\n.ph-metric-card:hover {\n  transform: translateY(-3px);\n  border-color: rgba(90, 175, 154, 0.35);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n.ph-metric-card__top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.ph-metric-card__icon {\n  font-size: 24px;\n}\n\n.ph-metric-badge {\n  font-size: 11px;\n  font-weight: 700;\n  padding: 3px 10px;\n  border-radius: 12px;\n  letter-spacing: 0.5px;\n}\n\n.badge--green {\n  background: rgba(40, 167, 69, 0.15);\n  color: #28a745;\n  border: 1px solid rgba(40, 167, 69, 0.3);\n}\n\n.badge--amber {\n  background: rgba(255, 193, 7, 0.15);\n  color: #ffc107;\n  border: 1px solid rgba(255, 193, 7, 0.3);\n}\n\n.badge--teal {\n  background: rgba(90, 175, 154, 0.15);\n  color: #5AAF9A;\n  border: 1px solid rgba(90, 175, 154, 0.3);\n}\n\n.badge--blue {\n  background: rgba(54, 162, 235, 0.15);\n  color: #36a2eb;\n  border: 1px solid rgba(54, 162, 235, 0.3);\n}\n\n.ph-metric-lbl {\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.ph-metric-val {\n  font-size: 26px;\n  font-weight: 800;\n  letter-spacing: -0.5px;\n  margin: 2px 0;\n}\n\n.ph-metric-card--funds .ph-metric-val { color: #5AAF9A; }\n.ph-metric-card--costs .ph-metric-val { color: #ffc107; }\n.ph-metric-card--facilitations .ph-metric-val { color: #28a745; }\n.ph-metric-card--resources .ph-metric-val { color: #36a2eb; }\n\n.ph-metric-sub {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.45);\n  line-height: 1.4;\n}\n\n/* ── Database Box ── */\n.ph-database-box {\n  max-width: 1200px;\n  margin: 0 auto;\n  background: rgba(14, 22, 14, 0.7);\n  backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 24px;\n  padding: 32px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.45);\n}\n\n.ph-db-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n  gap: 16px;\n  text-align: left;\n}\n\n.ph-db-title-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 6px;\n}\n\n.ph-db-title-row h3 {\n  font-size: 22px;\n  font-weight: 800;\n  color: #fff;\n}\n\n.ph-db-verified-badge {\n  font-size: 11px;\n  font-weight: 700;\n  background: rgba(90, 175, 154, 0.15);\n  color: #5AAF9A;\n  border: 1px solid rgba(90, 175, 154, 0.3);\n  padding: 3px 12px;\n  border-radius: 20px;\n}\n\n.ph-db-subtitle {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.55);\n}\n\n.ph-db-stats-pill {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  padding: 6px 16px;\n  font-size: 12.5px;\n  color: rgba(255, 255, 255, 0.75);\n}\n\n/* Search & Dropdown Controls */\n.ph-db-controls {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.ph-db-search {\n  flex: 1;\n  min-width: 280px;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.ph-db-search-icon {\n  position: absolute;\n  left: 16px;\n  font-size: 15px;\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.ph-db-search input {\n  width: 100%;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 50px;\n  padding: 12px 40px 12px 44px;\n  font-size: 13.5px;\n  color: #fff;\n  outline: none;\n  transition: border-color 0.2s ease;\n}\n\n.ph-db-search input:focus {\n  border-color: rgba(90, 175, 154, 0.6);\n}\n\n.ph-db-clear-btn {\n  position: absolute;\n  right: 14px;\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.4);\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.ph-db-dropdown-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n  min-width: 240px;\n}\n\n.ph-db-pin {\n  position: absolute;\n  left: 16px;\n  font-size: 14px;\n  pointer-events: none;\n}\n\n.ph-db-select {\n  width: 100%;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 50px;\n  padding: 12px 20px 12px 42px;\n  font-size: 13.5px;\n  color: #fff;\n  outline: none;\n  cursor: pointer;\n}\n\n.ph-db-select option {\n  background: #0d1a0d;\n  color: #fff;\n}\n\n/* Department Filter Pills */\n.ph-dept-pills {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-bottom: 24px;\n}\n\n.ph-dept-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 30px;\n  padding: 8px 18px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.7);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.ph-dept-pill:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n  border-color: rgba(255, 255, 255, 0.18);\n}\n\n.ph-dept-pill.active {\n  background: rgba(90, 175, 154, 0.2);\n  border-color: #5AAF9A;\n  color: #fff;\n  box-shadow: 0 4px 14px rgba(90, 175, 154, 0.2);\n}\n\n/* Ledger List & Rows */\n.ph-ledger-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 24px;\n  max-height: 480px;\n  overflow-y: auto;\n  padding-right: 6px;\n}\n\n.ph-ledger-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 14px;\n  padding: 16px 20px;\n  gap: 16px;\n  transition: background 0.2s ease, border-color 0.2s ease;\n  text-align: left;\n}\n\n.ph-ledger-row:hover {\n  background: rgba(255, 255, 255, 0.04);\n  border-color: rgba(90, 175, 154, 0.3);\n}\n\n.ph-row-main {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex: 1;\n  min-width: 0;\n}\n\n.ph-row-icon-wrap {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n  flex-shrink: 0;\n}\n\n.ph-row-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.ph-row-top {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.ph-dept-badge {\n  font-size: 10px;\n  font-weight: 700;\n  padding: 2px 8px;\n  border-radius: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.dept-healthcare {\n  background: rgba(0, 209, 178, 0.15);\n  color: #00d1b2;\n  border: 1px solid rgba(0, 209, 178, 0.25);\n}\n\n.dept-environmental-protection {\n  background: rgba(40, 167, 69, 0.15);\n  color: #28a745;\n  border: 1px solid rgba(40, 167, 69, 0.25);\n}\n\n.dept-human-protection {\n  background: rgba(255, 159, 67, 0.15);\n  color: #ff9f43;\n  border: 1px solid rgba(255, 159, 67, 0.25);\n}\n\n.dept-food-supply {\n  background: rgba(255, 205, 86, 0.15);\n  color: #ffcd56;\n  border: 1px solid rgba(255, 205, 86, 0.25);\n}\n\n.ph-row-location {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.55);\n}\n\n.ph-row-id {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.35);\n  font-family: monospace;\n}\n\n.ph-row-initiative {\n  font-size: 15px;\n  font-weight: 700;\n  color: #fff;\n  margin: 2px 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@media (max-width: 768px) {\n  .ph-row-initiative {\n    white-space: normal;\n  }\n  .ph-ledger-row {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .ph-row-financials {\n    align-self: flex-end;\n  }\n}\n\n.ph-row-meta {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  font-size: 11.5px;\n  color: rgba(255, 255, 255, 0.45);\n  flex-wrap: wrap;\n}\n\n.ph-row-audit {\n  color: #5AAF9A;\n  font-weight: 500;\n}\n\n.ph-row-financials {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.ph-row-amount {\n  font-size: 18px;\n  font-weight: 800;\n  color: #5AAF9A;\n  letter-spacing: -0.3px;\n}\n\n.ph-row-badge-disbursed {\n  font-size: 10px;\n  font-weight: 600;\n  background: rgba(90, 175, 154, 0.12);\n  color: #5AAF9A;\n  border: 1px solid rgba(90, 175, 154, 0.25);\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\n/* Empty state */\n.ph-ledger-empty {\n  text-align: center;\n  padding: 48px 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.ph-ledger-empty h4 {\n  color: #fff;\n  font-size: 16px;\n}\n\n.ph-reset-filters-btn {\n  margin-top: 8px;\n  background: rgba(90, 175, 154, 0.15);\n  border: 1px solid #5AAF9A;\n  color: #fff;\n  padding: 8px 20px;\n  border-radius: 20px;\n  font-size: 12.5px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.ph-reset-filters-btn:hover {\n  background: rgba(90, 175, 154, 0.3);\n}\n\n/* Database Footer */\n.ph-db-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  padding-top: 20px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.ph-db-footer-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.45);\n  max-width: 650px;\n  text-align: left;\n}\n\n.ph-db-footer-right {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.ph-db-subtotal-lbl {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.ph-db-subtotal-val {\n  font-size: 20px;\n  font-weight: 800;\n  color: #5AAF9A;\n}\n\n/* =====================================================================\n   FACILITATE PILLARS STYLES\n   ===================================================================== */\n.fac-pillars {\n  padding: 88px clamp(24px, 6vw, 100px);\n  background: #0d0e12;\n  position: relative;\n}\n\n.fac-pillars__eyebrow {\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 2px;\n  color: #5AAF9A;\n  background: rgba(90, 175, 154, 0.12);\n  border: 1px solid rgba(90, 175, 154, 0.28);\n  border-radius: 20px;\n  padding: 5px 14px;\n  margin-bottom: 12px;\n  text-align: center;\n  text-transform: uppercase;\n}\n\n.fac-pillars__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 24px;\n  margin-top: 44px;\n  max-width: 1200px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.fac-pillar-card {\n  display: flex;\n  flex-direction: column;\n  padding: 32px 28px;\n  background: rgba(18, 22, 28, 0.75);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 20px;\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);\n  transition: transform 0.22s ease, border-color 0.22s ease, box-shadow 0.22s ease;\n  position: relative;\n}\n\n.fac-pillar-card:hover {\n  transform: translateY(-5px);\n  border-color: rgba(90, 175, 154, 0.45);\n  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.5), 0 0 24px rgba(90, 175, 154, 0.14);\n}\n\n.fac-pillar-card__title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #fff;\n  margin-bottom: 10px;\n  line-height: 1.35;\n  letter-spacing: -0.2px;\n}\n\n.fac-pillar-card__desc {\n  font-size: 13.5px;\n  color: rgba(255, 255, 255, 0.65);\n  line-height: 1.6;\n  margin-bottom: 24px;\n  flex-grow: 1;\n}\n\n.fac-pillar-card__btn {\n  background: rgba(90, 175, 154, 0.12);\n  border: 1px solid rgba(90, 175, 154, 0.4);\n  color: #5AAF9A;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 8px 18px;\n  border-radius: 999px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  align-self: flex-start;\n  transition: all 0.2s ease;\n}\n\n.fac-pillar-card__btn span {\n  transition: transform 0.2s ease;\n}\n\n.fac-pillar-card__btn:hover {\n  background: #5AAF9A;\n  color: #0d0e12;\n  border-color: #5AAF9A;\n  box-shadow: 0 4px 14px rgba(90, 175, 154, 0.35);\n}\n\n.fac-pillar-card__btn:hover span {\n  transform: translateX(3px);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
